import { KEYBOARD_KEY_CODE } from 'constants/keyboard-key'
import PropTypes from 'prop-types'
import React from 'react'
import { debounceUtil } from 'packages/src'

class Form extends React.Component {
  constructor (props) {
    super(props)
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleSetDebounceOnSubmit()
    this._element = null
  }

  shouldBindEvents () {
    return this.props.onSubmit && this.props.onKeySubmit
  }

  componentDidMount () {
    if (this.shouldBindEvents()) {
      this.bindEvents()
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (
      prevProps.onSubmit !== this.props.onSubmit &&
      this.shouldBindEvents()
    ) {
      this.handleSetDebounceOnSubmit()
    }
  }

  componentWillUnmount () {
    if (this.shouldBindEvents()) {
      this.unbindEvents()
    }
  }

  handleSetDebounceOnSubmit () {
    if (this.props.onSubmit) {
      this._debouncedOnSubmitProp = debounceUtil(this.props.onSubmit, 0)
    } else {
      this._debouncedOnSubmitProp = null
    }
  }

  handleKeyPress (event) {
    if (event.keyCode === KEYBOARD_KEY_CODE.ENTER) {
      this.handleSubmit(event)
    }
  }

  handleSubmit (event) {
    event.preventDefault()
    event.stopPropagation()
    const { _debouncedOnSubmitProp } = this
    if (_debouncedOnSubmitProp) {
      _debouncedOnSubmitProp()
    }
    return false
  }

  bindEvents () {
    this._element.addEventListener('keypress', this.handleKeyPress)
  }

  unbindEvents () {
    this._element.removeEventListener('keypress', this.handleKeyPress)
  }

  render () {
    return (
      <form
        ref={(element) => {
          this._element = element
        }}
        onSubmit={this.handleSubmit}
        style={{
          width: '100%'
        }}
      >
        {this.props.children}
      </form>
    )
  }
}

Form.propTypes = {
  onKeySubmit: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
  onSubmit: PropTypes.func
}

Form.defaultProps = {
  onKeySubmit: true
}
export default Form
